
import {Icon, IconNode} from "lucide-react";
import React from "react";


const ClockRotateLeftIconNode: IconNode = [
    [
        "path",
        {
            d: "M4.22266 4.22266L2.76172 2.76172C2.11289 2.11289 1 2.57266 1 3.48789V8.21875C1 8.79023 1.45977 9.25 2.03125 9.25H6.76211C7.68164 9.25 8.14141 8.13711 7.49258 7.48828L6.16914 6.16484C7.66016 4.67383 9.72266 3.75 12 3.75C16.5547 3.75 20.25 7.44531 20.25 12C20.25 16.5547 16.5547 20.25 12 20.25C10.2469 20.25 8.62266 19.7043 7.28633 18.7719C6.66328 18.3379 5.8082 18.4883 5.36992 19.1113C4.93164 19.7344 5.08633 20.5895 5.70937 21.0277C7.49687 22.2695 9.6668 23 12 23C18.0758 23 23 18.0758 23 12C23 5.92422 18.0758 1 12 1C8.96211 1 6.21211 2.2332 4.22266 4.22266ZM12 6.5C11.4285 6.5 10.9688 6.95977 10.9688 7.53125V12C10.9688 12.275 11.0762 12.5371 11.2695 12.7305L14.3633 15.8242C14.7672 16.2281 15.4203 16.2281 15.8199 15.8242C16.2195 15.4203 16.2238 14.7672 15.8199 14.3676L13.027 11.5746V7.53125C13.027 6.95977 12.5672 6.5 11.9957 6.5H12Z",
            key: "path0ClockRotateLeft",
        }
    ]
];

interface ClockRotateLeftProps {
    size?: string | number;
    className?: string;
}

export default function ClockRotateLeft({ size, className }: ClockRotateLeftProps) {
    return (
        <Icon iconNode={ClockRotateLeftIconNode} size={size} className={className} fill="#5C5C5C" color="transparent" />
    );
}
